export const PATHS = {
  HOME: '/',
  LOGIN: '/login',
  LOGOUT: '/logout',
  WORK_SESSIONS: '/work-sessions',
};
